<template>
  <div class="custom-modal-mask" v-if="visible" @click.self="close">
    <div class="custom-modal wrong-dialog" style="width: 800px;">
      <div class="custom-modal-header">
        <span class="modal-title">错题集 <span class="count">共{{ wrongTotal }}题</span></span>
        <span class="custom-modal-close" @click="close">&times;</span>
      </div>
      <div class="custom-modal-body">
        <div v-for="(item, idx) in wrongList" :key="item.id" class="wrong-q-item">
          <div class="wrong-q-head">
            <span class="wrong-q-num">{{ (wrongPage - 1) * wrongPageSize + idx + 1 }}</span>
            <span class="wrong-q-type" :class="{ judge: item.type === 'JUDGMENT' }">{{ quesMap[item.type] || item.type }}</span>
            <span class="wrong-q-title" v-html="item.content"></span>
            <span class="wrong-q-time" v-if="item.createdTime">{{ item.createdTime }}</span>
            <span class="wrong-q-delete" @click="deleteWrongItem(item)">删除</span>
          </div>
          <ul class="q-options" v-if="item.options && item.options.length">
            <li v-for="(opt, oi) in item.options" :key="oi" :class="getOptionClass(item, opt.alisa)">
              <span class="radio"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
            </li>
          </ul>
          <div class="analysis-box">
            <p class="label">解析</p>
            <p class="answer">正确答案：{{ item.answer }} &nbsp; 你的答案：{{ formatUserAnswer(item) }} ✗</p>
            <p class="detail" v-if="item.analysis"><span v-html="item.analysis"></span></p>
          </div>
        </div>
        <div class="empty-state" v-if="wrongList.length === 0">
          <div class="icon">📋</div>
          <p>暂无错题</p>
        </div>
      </div>
      <div class="wrong-pagination">
        <el-pagination
          layout="prev, pager, next"
          :total="wrongTotal"
          :page-size="wrongPageSize"
          :current-page.sync="wrongPage"
          @current-change="getWrongList"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { quesMap } from "@/utils/enums";

export default {
  name: "WrongModal",
  props: {
    visible: { type: Boolean, default: false },
    courseId: { type: String, default: '' },
    paperId: { type: String, default: '' },
  },
  data() {
    return {
      quesMap,
      wrongList: [],
      wrongTotal: 0,
      wrongPage: 1,
      wrongPageSize: 10,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.wrongPage = 1;
        this.getWrongList();
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    getWrongList() {
      const params = { courseId: this.courseId, current: this.wrongPage, size: this.wrongPageSize };
      if (this.paperId) params.paperId = this.paperId;
      this.$http.get('/student/pc/freeStudy/wrongList', params).then(res => {
        this.wrongList = res.records || [];
        this.wrongTotal = res.total || 0;
      });
    },
    deleteWrongItem(item) {
      this.$confirm('确定要删除这道错题吗？此操作不可恢复。', '删除错题', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/deleteWrong', { questionId: item.id, courseId: this.courseId }).then(() => {
          this.$message.success('删除成功');
          this.getWrongList();
          this.$emit('deleted');
        });
      }).catch(() => {});
    },
    getOptionClass(q, val) {
      if (q.type === 'MULTIPLECHOICE') {
        const isAnswer = q.answer && q.answer.includes(val);
        const isUser = q.userAnswer && q.userAnswer.includes(val);
        if (isAnswer) return { correct: true };
        if (isUser && !isAnswer) return { wrong: true };
        return {};
      }
      if (val === q.answer) return { correct: true };
      if (val === q.userAnswer && val !== q.answer) return { wrong: true };
      return {};
    },
    formatUserAnswer(q) {
      if (q.type === 'JUDGMENT') {
        return q.userAnswer === 'Y' ? '正确' : '错误';
      }
      if (Array.isArray(q.userAnswer)) return q.userAnswer.join('');
      return q.userAnswer || '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.custom-modal-mask {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.5);
  z-index: 2000; display: flex; align-items: flex-start; justify-content: center; padding-top: 8vh;
  overflow-y: auto;
}
.custom-modal {
  background: #fff; border-radius: 10px; border: 1px solid #e3e3e3; box-shadow: 0 4px 20px rgba(0,0,0,.15);
  max-height: 84vh; display: flex; flex-direction: column;
}
.custom-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 24px; background: $primary-light; border-bottom: 1px solid $primary-border; border-radius: 10px 10px 0 0; flex-shrink: 0;
  .modal-title { font-size: 15px; font-weight: bold; color: #333; }
  .count { font-size: 13px; font-weight: normal; color: #999; margin-left: 8px; }
}
.custom-modal-close {
  font-size: 22px; color: #999; cursor: pointer; line-height: 1; padding: 0 4px;
  &:hover { color: #333; }
}
.custom-modal-body {
  flex: 1; overflow-y: auto; padding: 20px 24px;
}
.empty-state { text-align: center; padding: 60px 0; color: #999; font-size: 14px; .icon { font-size: 48px; margin-bottom: 16px; color: #ddd; } }
.q-options {
  list-style: none; padding: 0;
  li {
    padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3;
    font-size: 14px; display: flex; align-items: center; gap: 8px;
    .radio { width: 16px; height: 16px; border-radius: 50%; border: 2px solid #ccc; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    &.correct { border-color: #67c23a; background: #f0f9eb; .radio { border-color: #67c23a; background: #67c23a; &::after { content: '\2713'; color: #fff; font-size: 10px; line-height: 1; } } }
    &.wrong { border-color: #f56c6c; background: #fef0f0; .radio { border-color: #f56c6c; &::after { content: '\2717'; color: #f56c6c; font-size: 10px; line-height: 1; } } }
  }
}
.analysis-box {
  background: #f9f9f9; border-radius: 8px; padding: 14px 18px; margin-top: 12px; border-left: 3px solid $primary-dark;
  .label { font-size: 13px; color: $primary-dark; font-weight: bold; margin-bottom: 6px; }
  .answer { font-size: 13px; color: #333; margin-bottom: 4px; }
  .detail { font-size: 13px; color: #666; line-height: 1.8; }
}
.wrong-q-item { padding: 20px 24px; border-bottom: 1px solid #f2f2f2; &:last-child { border-bottom: none; } }
.wrong-q-head { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.wrong-q-num { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: #fef0f0; color: #f56c6c; font-size: 13px; font-weight: bold; flex-shrink: 0; }
.wrong-q-type { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; background: $primary-light; color: $primary-dark; font-weight: bold; &.judge { background: #fff3e0; color: #e6a23c; } }
.wrong-q-title { flex: 1; font-size: 14px; color: #333; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
.wrong-q-time { font-size: 12px; color: #999; white-space: nowrap; flex-shrink: 0; }
.wrong-q-delete { display: inline-flex; align-items: center; padding: 3px 12px; font-size: 12px; color: #f56c6c; border: 1px solid #f56c6c; border-radius: 14px; cursor: pointer; background: #fff; flex-shrink: 0; &:hover { background: #fef0f0; } }
.wrong-pagination { padding: 16px 24px; border-top: 1px solid #f2f2f2; display: flex; justify-content: center; flex-shrink: 0; }
</style>
